import { nanoid } from "nanoid";
import React, { useEffect, useState } from "react";
import "./Shared.scss";

const Skeleton = ({ schema, width = 100, align, animation = "slide" }) => {
    const [elements, setElements] = useState(null);

    const generator = () => {
        let toRender = [];
        for (let i = 0; i < schema.length; i += 1) {
            let row = schema[i];
            let rowElements = [];
            for (let j = 0; j < row.length; j += 1) {
                rowElements.push(
                    <div
                        style={{
                            height: `${row[j][1]}px`,
                            width: `${row[j][0]}%`,
                        }}
                        className="skeleton__item"
                        key={nanoid(3)}
                    />
                );
            }

            toRender.push(<>{rowElements}</>);
        }

        return toRender;
    };

    useEffect(() => {
        let res = null;
        schema?.length > 0 && (res = generator());
        setElements(res);
    }, [schema]);

    return (
        <div
            className={`skeleton__wrapper skeleton__${animation}`}
            style={{ width: `${width}%`, alignContent: align ?? "" }}
        >
            {elements}
        </div>
    );
};

export default Skeleton;
